// =====================================
// search-analytics.interfaces.ts
// =====================================

import {AdvertStatusEnum, SoldStatusEnum} from "../../../enums";
import { BaseSearchDTO } from "../API";

// export interface OrderByDTO {
//   column: string;
//   descending?: boolean;
// }

// export interface BaseSearchDTO {
//   component?: string;
//   includes?: string[];
//   order?: OrderByDTO[];
//   columns?: string[];
//   offset?: number;
//   limit?: number;
//   countOnly?: boolean;
//   lockRecord?: boolean;
//   currentCustomerId?: string;
//   currentContactId?: string;
//   invalidateCache?: boolean;
//   useCache?: boolean;
// }

// Filter DTOs
export interface AdminCustomerSearchFilters {
  customerName?: string;
  customerEmail?: string;
  assignedTo?: string;
  fromDate?: Date;
  toDate?: Date;
  minEffectivenessRate?: number;
  maxEffectivenessRate?: number;
}

export interface AdminAdvertSearchFilters {
  vrm?: string;
  advertStatus?: string;
  soldStatus?: string;
  fromDate?: Date;
  toDate?: Date;
  minNotificationRate?: number;
  maxNotificationRate?: number;
}

// Search DTOs
export interface CustomerAnalyticsSearchDTO extends BaseSearchDTO {
  filters: AdminCustomerSearchFilters;
}

export interface AdvertAnalyticsSearchDTO extends BaseSearchDTO {
  filters: AdminAdvertSearchFilters;
}

// Main Analytics DTOs
export interface SavedSearchStatsDTO {
  savedSearchId: string;
  searchCriteria: string;
  notificationsEnabled: boolean;
  totalMatchingAdverts: number;
  totalAdvertsNotifiedAbout: number;
  notificationEffectivenessRate: number;
  lastNotificationSent?: Date;
  createdDate: Date;
}

export interface AdminCustomerSearchAnalyticsDTO {
  customerId: string;
  customerName: string;
  customerEmail: string;
  assignedTo?: string;
  totalSavedSearches: number;
  activeNotificationSearches: number;
  totalMatchingAdverts: number;
  totalAdvertsNotifiedAbout: number;
  notificationEffectivenessRate: number;
  savedSearches: SavedSearchStatsDTO[];
}

export interface AdvertNotificationStatsDTO {
  advertId: string;
  vrm: string;
  description: string;
  customerName: string;
  customerId: string;
  added: Date;
  updated: Date;
  advertStatus: AdvertStatusEnum;
  soldStatus: SoldStatusEnum;
  matchedInSavedSearchCount: number;
  matchedInUnsavedSearchCount: number;
  contactsNotifiedAbout: number;
  notificationEffectivenessRate: number;
  notificationEffectiveness: string;
}

export interface SystemMetricSummaryDTO {
  name: string;
  value: string;
  description: string;
  trendIndicator: string;
}

export interface AdminSearchSystemOverviewDTO {
  totalCustomers: number;
  customersWithNoSearches: number;
  totalSavedSearches: number;
  activeSavedSearches: number;
  totalActiveAdverts: number;
  totalAdvertsNotifiedAbout: number;
  customerEngagementRate: number;
  systemHealthStatus: string;
  keyMetrics: SystemMetricSummaryDTO[];
}

// Enums
// export enum AdvertStatusEnum {
//   Active = 'Active',
//   Inactive = 'Inactive',
//   Sold = 'Sold',
//   Expired = 'Expired',
//   Draft = 'Draft'
// }
//
// export enum SoldStatusEnum {
//   Active = 'Active',
//   Sold = 'Sold',
//   Reserved = 'Reserved',
//   Withdrawn = 'Withdrawn'
// }
